import styled from "styled-components";
import { ErrorLabel } from "./error.styles";
export const StyledWrapper = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  ${({ indented }) => (indented ? "margin-left: 2.25rem;" : "")}
  min-height: 1.5rem;

  ${({ alignByContent }) => {
    const translationValue = 8;
    return alignByContent === "left"
        ? `transform: translate(-${translationValue}px);`
        : alignByContent === "right"
            ? `transform: translate(${translationValue}px);`
            : "";
}}

  & > span:not(.charactersInfoStyled, ${ErrorLabel}) {
    display: flex;
    justify-content: center;
    height: auto;
    width: 2.5rem;
    position: absolute;
    left: 0;
    bottom: 0;
  }

  & > span + label,
  & > span ~ input,
  & > span + select,
  & > span ~ select {
    margin-left: 2.5rem;
  }

  div > button {
    position: absolute;
    right: 0;
    bottom: 0;
  }

  div > span {
    position: absolute;
    right: 0;
    bottom: 0;
  }

  label,
  label a {
    max-width: max-content;
    ${({ multiLine }) => multiLine
    ? "padding-top: 0.75rem; padding-bottom: 0.5rem;"
    : "padding-top: 0.625rem; padding-bottom: 0.625rem;"}
  }

  label {
    padding-right: 0.5rem;
  }

  && label {
    & > span {
      display: none;
      position: absolute;
      z-index: 1;
      ${({ type, theme }) => type === "radio"
    ? `border-radius: 50%; 
            left: 0.875rem;
            top: 0.875rem;
            width: 0.75rem; 
            height: 0.75rem; 
            background-color: ${theme.colors.grey15};`
    : "left: 0.75rem;"}
      ${({ type }) => type === "checkbox" ? "left: 0.75rem; top: 0.75rem;" : ""}
      ${({ type }) => type === "checkboxGroup" ? "left: 0.75rem; top: 0.75rem;" : ""}
    }
    p {
      line-height: 1rem;
      span:last-child {
        padding: 1px 1px;
        box-sizing: border-box;
        line-height: 0.875rem;
      }
    }
  }

  @supports (-moz-appearance: none) {
    button {
      ${({ type, values, name }) => { var _a; return type === "date" && ((_a = values === null || values === void 0 ? void 0 : values[name]) === null || _a === void 0 ? void 0 : _a.length) > 0 ? "display: none" : ""; }}
    }
  }

  ${({ type, values, name, theme, indented }) => {
    var _a, _b;
    return `&:first-of-type {
        ${indented ? "margin-left: 0;" : ""};

        input + label {
          & > span {
            display: ${type === "checkboxGroup" && ((_a = values === null || values === void 0 ? void 0 : values[name]) === null || _a === void 0 ? void 0 : _a.length) >= 1
        ? "block"
        : ""};
          }

          &:after {
            ${type === "checkboxGroup" && ((_b = values === null || values === void 0 ? void 0 : values[name]) === null || _b === void 0 ? void 0 : _b.length) >= 1
        ? `background-color: ${theme.colors.grey15}`
        : ""};
          }
      }
    }`;
}}

  @media ${({ theme }) => theme.device.touch} {
    min-height: auto;

    ${({ alignByContent }) => {
    const transaltionValue = 10;
    return alignByContent === "left"
        ? `transform: translate(-${transaltionValue}px);`
        : alignByContent === "right"
            ? `transform: translate(${transaltionValue}px);`
            : "";
}}

    && label {
      ${({ multiLine }) => multiLine
    ? "padding-top: 0.875rem; padding-bottom: 0.625rem;"
    : "padding-top: 0.75rem; padding-bottom: 0.75rem;"}

      & > span {
        display: none;
        position: absolute;
        z-index: 1;
        ${({ type, theme }) => type === "radio"
    ? `left: 1rem;top: 1rem;border-radius: 50%;width: 0.75rem;height: 0.75rem;background-color: ${theme.colors.grey15};`
    : "left: 0.75rem;"}
        ${({ type }) => type === "checkbox" ? "left: 0.875rem; top: 0.875rem;" : ""}
      }
    }
  }
`;
export const AlignmentWrapper = styled.div `
  display: flex;
  flex-direction: ${({ alignment }) => alignment === "horizontal" ? "row" : "column"};

  ${StyledWrapper} {
    ${({ alignment }) => alignment === "horizontal" ? "margin-right: 1.5rem" : ""};

    &:last-of-type {
      ${({ alignment }) => alignment === "horizontal" ? "margin-right: 0" : "margin-bottom: 0"};
    }
  }
`;
